export default import.meta.ROLLDOWN_FILE_URL_hK71SRfysxqxFJEij39IfQ